import { gql } from '@parkchirp/api-client';

export const GET_DAILY_REVENUE_REPORT_CSV = gql`
    query getDailyRevenueReportCsv(
        $facilityId: String!,
        $startDate: String!,
        $endDate: String!,
    ) {
        getDailyRevenueReportCsv(
            facilityId: $facilityId,
            startDate: $startDate,
            endDate: $endDate,
        ) {
            url
        }
    }
`;
